import React, { Component } from "react";
import { connect } from "react-redux";
import xss from "xss";

import { panelActions } from "../actions";

class Sort extends Component {
  constructor(props) {
    super(props);
    this.handleOrderClick = this.handleOrderClick.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
  }
  handleOrderClick(e) {
    this.props.dispatch(panelActions.setOrder(e.target.dataset.order));
  }

  handleChangeOrder(e) {
    this.props.dispatch(panelActions.setOrder(xss(e.target.value)));
  }

  handleChangePageSize(e) {
    this.props.dispatch(panelActions.setPageSize(xss(e.target.value)));
  }

  render() {
    let orders = Array.isArray(this.props.orders) ? this.props.orders : [];
    let pageSizes = [2, 3, 4, 6, 8, 9, 12];
    let isOrderActive = this.props.panelStorage.isOrderActive;
    return (
      <div className="ser-panel ser-sortpagi" >
        <div className="ser-sortpanel ser-iblock">
          <div className="ser-iblock ser-label">Sortierung:</div>
          <div className="ser-iblock ser-sortlinks">
            {orders.map((order) => {
              return (
                <button type="button"
                  key={order.id}
                  className={
                    "btn-link ser-orderbut ser-iblock" +
                    (isOrderActive(order.id) ? " active" : "")
                  }
                  data-order={order.id}
                  onClick={this.handleOrderClick}
                  aria-label={"Sortierung nach " + order["name"] + (isOrderActive(order.id) ? " aktiviert" : "")}
                >
                  {order['name']}
                </button>
              );
            })}
          </div>
          <select
            id="sortierung"
            aria-label="Sortierung"
            className="d-lg-none form-select"
            value={this.props.panelStorage.getOrder()}
            onChange={this.handleChangeOrder}
          >
            {orders.map((order, index) => {
              return <option
                key={"opt" + order.id}
                value={order.id}
              >
                {order.name}
              </option>;
            })}
          </select>
        </div>
        <div className="ser-pagipanel ser-iblock">
          <span>Zeige </span>
          <select
            id="pageSize"
            className="ser-select"
            defaultValue={this.props.panelStorage.getPageSize()}
            onChange={this.handleChangePageSize}
            aria-label="Anzahl der Produkte pro Seite"
          >
            {pageSizes.map((pageSize) => {
              let classVal = this.props.panelStorage.isPageSizeActive(pageSize)
                ? "ser-2col"
                : "";
              return (
                <option key={"size_" + pageSize} className={classVal} value={pageSize}>
                  {pageSize}
                </option>
              );
            })}
          </select>
          <label htmlFor="pageSize"><span> pro Seite</span></label>
        </div>
      </div>
    );
  }
}

export default connect(store => {
  return {
    panelStorage: store.panelStorage
  };
})(Sort);
